import { sharedTranslationsDe, sharedTranslationsEn } from "../../../../../../shared/frontend/i18n/sharedTranslations";
import { apiErrorMessagesDe } from "./generated/apiErrorMessages.de";
import { apiErrorMessagesEn } from "./generated/apiErrorMessages.en";
import { de as deTranslations } from "./translations.de";
import { en as enTranslations } from "./translations.en";

export type Lang = "de" | "en";

export type LocalizedText = string | { de: string; en: string };

/**
 * Basiswoerterbuch plus erzeugte API-Fehlertexte (E_...) plus die Uebersetzungen der
 * Shared-Bausteine. Es wird bewusst das Sammelwoerterbuch aus `shared/frontend/i18n` gemerged und
 * nicht einzelne Moduldateien — sonst zeigt jede neu eingebundene Shared-Komponente stumm ihre
 * rohen Schluessel auf Englisch. Shared kommt zuerst, produkteigene Schluessel ueberschreiben.
 */
const deAll = { ...sharedTranslationsDe, ...deTranslations, ...apiErrorMessagesDe } as typeof deTranslations & Record<string, string>;
const enAll = { ...sharedTranslationsEn, ...enTranslations, ...apiErrorMessagesEn } as typeof enTranslations & Record<string, string>;

export function normalizeLang(input: string | null | undefined): Lang | null {
  const s = (input || "").trim().toLowerCase();
  if (!s) return null;
  if (s.startsWith("de")) return "de";
  if (s.startsWith("en")) return "en";
  return null;
}

export function pickLang(params: {
  unitsLocale?: string | null;
  userLanguage?: string | null;
  storedLanguage?: string | null;
  browserLanguage?: string | null;
}): Lang {
  return (
    normalizeLang(params.userLanguage) ||
    normalizeLang(params.storedLanguage) ||
    normalizeLang(params.unitsLocale) ||
    normalizeLang(params.browserLanguage) ||
    "de"
  );
}

/** Returns true when the key exists in at least one translation file. */
export function hasTranslationKey(key: string): boolean {
  return key in enAll || key in deAll;
}

export function translateKey(lang: Lang, key: string): string {
  if (lang === "de") return deAll[key] ?? key;
  return enAll[key] ?? key;
}

export function textFor(lang: Lang, value: LocalizedText): string {
  if (typeof value === "string") {
    return translateKey(lang, value);
  }
  return lang === "en" ? value.en : value.de;
}
